// ad-api — 广告数据层。
// 走 /gapi/public/ad/feed?slot=<type>(无需登录)。
// staleTime 1 小时:与 computeVisible 的 hourBucket 对齐,避免同一小时反复请求。
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@dogdisk/shared'
import type { Ad } from './ad-rotate'
import type { AdSlotType } from './ad-slot'

export type AdFeedResp = {
  order_mode: 'fixed' | 'random'
  ads: Ad[]
}

const STALE_MS = 3_600_000 // 1 小时

/** useAdFeed — 拉取指定广告位的广告列表 + 排序模式。无广告时 ads=[]。 */
export function useAdFeed(slot: AdSlotType) {
  return useQuery({
    queryKey: ['ad', 'feed', slot] as const,
    staleTime: STALE_MS,
    queryFn: async (): Promise<AdFeedResp> => {
      const resp = await apiClient.get<AdFeedResp>(`/gapi/public/ad/feed?slot=${slot}`)
      return resp
    },
  })
}
